import {Component, Inject, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import {ConfService} from '../../conf.service';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {EmailtemplateService} from '../../emailtemplate.service';
import * as CryptoJS from 'crypto-js';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-add-environment',
    templateUrl: './add-environment-dialog.component.html',
    styleUrls: ['./add-environment-dialog.component.scss']
})
export class AddEnvironmentDialogComponent implements OnInit {


    constructor(public platform: LeftpanelComponent, public dialogRef: MatDialogRef<AddEnvironmentDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, private confPost: ConfService, private _snackBar: MatSnackBar, public _service: ConnecttocrudService, public emailTemplateInstance: EmailtemplateService) {
    }

    selectedEnvironmentList = new FormControl();

    environmentList: string[];
    password: any;
    shash: any;
    ralam: any;
    encyptedPassword: any;
    partnerShortName: any;

    ngOnInit() {
        this.partnerShortName = localStorage.getItem('partner').split('-');
        this.environmentList = this.data['environmentList'];
    }

    addEnvironment() {
        if (this.password && this.password !== undefined) {
            this.platform.passwordPolicyValidator(this.password).then(status => {
                if (status) {
                    const iterationCount = 1000;
                    let keySize = 128;
                    keySize = keySize / 32;
                    const passphrase = environment.cipheringPhrase;
                    const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                    const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                    const cipherText = this.platform.encrypt(salt, iv, passphrase, this.password, keySize, iterationCount);
                    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'id=' + this.data['id']).subscribe(async result => {
                        if (result) {
                            const userResponse = result[0];

                            for (const environment of this.selectedEnvironmentList.value) {
                                const roleDetails = {
                                    'role': environment + '=>' + environment + '=>' + this.data['emailId'],
                                    'permission_groups': [],
                                    'permissions': [],
                                    'roles': [],
                                    'exclusions': [],
                                    'partner': environment,
                                    'account': environment,
                                    'type': 'account'
                                };
                                const roleId = await this.createRoleForEachEnvironment(roleDetails);
                                userResponse['environments'].push(
                                    {
                                        name: environment,
                                        account: environment,
                                        roles: [roleId],
                                        exclusions: {
                                            permissions: [],
                                            permission_groups: [],
                                            roles: []
                                        },
                                        audit_logs: [
                                            {
                                                action: 'UPDATE',
                                                by: localStorage.getItem('signInEmail'),
                                                at: Date.now()
                                            }
                                        ],
                                        password: cipherText,
                                        shash: salt,
                                        ralam: iv
                                    }
                                );


                            }
                            this._service.patchItemUpdate(this.data['id'], {environments: userResponse['environments']}, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(res => {
                                if (res) {
                                    this.dialogRef.close('success');
                                }
                            });
                        }
                    });
                } else {
                    this.platform.openSnackBar(' Please make sure that your password follows our password policy ', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }

            });
        }

    }

    createRoleForEachEnvironment(roleDetail) {
        return new Promise((resolve, reject) => {
            this._service.addItem(roleDetail, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(data => {
                if (data) {
                    resolve(data['upsertedId']);
                } else {
                    resolve('failed');
                }
            }, error => {
                /*this.platform.notifyErrorToAdmins({error: 'Error occurred while creating role for the user ' + roleDetail['role']}, 'role_create_success', 'role_create_failed', 'Error occurred while creating role for the user ' + roleDetail['role'], roleDetail);
                */resolve('failed');
            });
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }


}
